import React from "react";

export const Eyebrow = ({ children, className = "" }) => (
  <span className={`inline-block font-mono text-xs uppercase tracking-[0.25em] text-primary ${className}`}>
    [ {children} ]
  </span>
);

export const SectionHeading = ({ eyebrow, title, sub, align = "left", titleClassName = "", id, as: As = "h2" }) => (
  <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`} id={id}>
    {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
    <As className={`mt-4 font-display font-black text-3xl sm:text-4xl lg:text-5xl tracking-tightest leading-[1.05] text-ink ${titleClassName}`}>
      {title}
    </As>
    {sub && <p className="mt-5 text-muted text-lg leading-relaxed">{sub}</p>}
  </div>
);

export const Stat = ({ value, label }) => (
  <div className="border border-line bg-white px-6 py-7">
    <div className="font-display text-4xl sm:text-5xl font-black tracking-tightest text-primary">{value}</div>
    <div className="mt-2 font-mono text-[10px] uppercase tracking-[0.25em] text-muted">{label}</div>
  </div>
);
